import {CommunicationMethodName} from '~/shared/services/bffService/api/interfaces/payloads';

export enum ToggleName {
  PROMOTIONS = 'promotions',
  RES_REVIEW = 'resReview',
}

export type SettingControllerName = ToggleName | CommunicationMethodName;
